"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageCache = void 0;
var observables_1 = require("icf-search-client-shared/lib/observables");
var Subscribable_1 = require("icf-search-client-shared/lib/observables/Subscribable");
var Utilities_1 = require("icf-search-client-shared/lib/Utilities");
var PageCache = /** @class */ (function () {
    function PageCache(dataProvider, pageSize, dataUpdateProvider, ttlMs) {
        if (ttlMs === void 0) { ttlMs = Number.MAX_SAFE_INTEGER; }
        var _this = this;
        this._version = 0;
        this._cachedPages = new Map();
        this._pageRequestStarted = new Subscribable_1.Subscribable();
        this._pageRequestCompleted = new Subscribable_1.Subscribable();
        this._totalItemCount = new observables_1.Observable(0);
        this._totalOnlineItemCount = new observables_1.Observable(0);
        this._dataProvider = dataProvider;
        this._dataUpdateProvider = dataUpdateProvider;
        this._pageSize = pageSize;
        this._ttlMs = ttlMs;
        this._onReset = new Subscribable_1.Subscribable();
        this._hasInitialResults = new observables_1.ComputedObservable(function () { return Array.from(_this._cachedPages.values()).some(function (p) { return p.pagePromise.completed.value; }); }, [this._pageRequestStarted, this._pageRequestCompleted, this._onReset]);
    }
    Object.defineProperty(PageCache.prototype, "hasInitialResults", {
        get: function () {
            return this._hasInitialResults;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageCache.prototype, "pageRequestStarted", {
        get: function () {
            return this._pageRequestStarted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageCache.prototype, "pageRequestCompleted", {
        get: function () {
            return this._pageRequestCompleted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageCache.prototype, "totalOnlineItemCount", {
        get: function () {
            return this._totalOnlineItemCount.asReadonly();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageCache.prototype, "totalItemCount", {
        get: function () {
            return this._totalItemCount.asReadonly();
        },
        enumerable: false,
        configurable: true
    });
    PageCache.prototype.getPages = function (pageIndex, pageCount) {
        var _a, _b, index, e_1_1;
        var e_1, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, 6, 7]);
                    _a = __values((0, Utilities_1.numberRangeIterator)(pageIndex, pageCount)), _b = _a.next();
                    _d.label = 1;
                case 1:
                    if (!!_b.done) return [3 /*break*/, 4];
                    index = _b.value;
                    return [4 /*yield*/, this.getPage(index)];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    _b = _a.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    };
    PageCache.prototype.getPage = function (pageIndex) {
        var previousResults = this._cachedPages.has(pageIndex)
            ? this._cachedPages.get(pageIndex).pageResults
            : undefined;
        if (!this._cachedPages.has(pageIndex) || !this._isCacheEntryValid(this._cachedPages.get(pageIndex))) {
            this._cachedPages.set(pageIndex, this._createNewCacheEntry(pageIndex, previousResults));
        }
        return this._cachedPages.get(pageIndex);
    };
    PageCache.prototype.reset = function () {
        this._cachedPages.clear();
        this._version++;
        this._totalItemCount.value = 0;
        this._totalOnlineItemCount.value = 0;
        this._onReset.notifySubscribers();
    };
    PageCache.prototype.updateData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var equalityComparer, matchingEntry, updatedData, dataIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._dataUpdateProvider) {
                            return [2 /*return*/];
                        }
                        equalityComparer = this._dataUpdateProvider.equalityComparer;
                        matchingEntry = this._findCompletedCacheEntryForData(data, equalityComparer);
                        if (!matchingEntry) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this._dataUpdateProvider.getUpdatedData(data)];
                    case 1:
                        updatedData = _a.sent();
                        if (!updatedData) {
                            return [2 /*return*/];
                        }
                        dataIndex = matchingEntry.pageResults.results.findIndex(function (d) { return equalityComparer(data, d); });
                        matchingEntry.pageResults.results[dataIndex] = updatedData;
                        this._pageRequestCompleted.notifySubscribers(matchingEntry);
                        return [2 /*return*/, updatedData];
                }
            });
        });
    };
    PageCache.prototype.dispose = function () {
        this._pageRequestCompleted.dispose();
        this._pageRequestStarted.dispose();
        this._totalItemCount.dispose();
        this._totalOnlineItemCount.dispose();
        this._onReset.dispose();
        this._hasInitialResults.dispose();
    };
    PageCache.prototype._findCompletedCacheEntryForData = function (data, equalityComparer) {
        var e_2, _a;
        try {
            for (var _b = __values(this._cachedPages.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var entry = _c.value;
                if (!entry.pagePromise.completed.value) {
                    continue;
                }
                if (entry.currentResults && entry.currentResults.results.some(function (d) { return equalityComparer(data, d); })) {
                    return entry;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return null;
    };
    PageCache.prototype._isCacheEntryValid = function (entry) {
        return !entry.pagePromise.error.value && Date.now() - entry.pagePromise.completionTimeMs.value < this._ttlMs;
    };
    PageCache.prototype._createNewCacheEntry = function (pageIndex, previousResults) {
        var _this = this;
        var requestPromise = new observables_1.ObservablePromise(this._dataProvider({
            pageIndex: pageIndex,
            pageSize: this._pageSize,
        }, previousResults));
        var cacheEntry = {
            pageIndex: pageIndex,
            pageSize: this._pageSize,
            pagePromise: requestPromise,
            previousResults: previousResults,
            get pageResults() {
                return requestPromise.value.value ? requestPromise.value.value : previousResults;
            },
            get currentResults() {
                return requestPromise.value.value;
            },
        };
        var version = this._version;
        this._pageRequestStarted.notifySubscribers(cacheEntry);
        (0, Utilities_1.settled)(cacheEntry.pagePromise.promise).then(function () {
            var _a;
            if (_this._version !== version) {
                return;
            }
            if (cacheEntry.pagePromise.value.value) {
                _this._totalItemCount.value = cacheEntry.pagePromise.value.value.totalItems;
                _this._totalOnlineItemCount.value = (_a = cacheEntry.pagePromise.value.value.totalOnlineItems) !== null && _a !== void 0 ? _a : 0;
            }
            _this._pageRequestCompleted.notifySubscribers(cacheEntry);
        });
        return cacheEntry;
    };
    return PageCache;
}());
exports.PageCache = PageCache;
//# sourceMappingURL=PageCache.js.map